import styled from 'styled-components';
import { BREAKPOINTS } from '../../../../app/appConstants.js';

export const TransactionsModalStyled = styled.div`
    background: var(--app-bg-modal-color);
    min-height: 768px;
    font-size: 14px;

    display: flex;
    flex-direction: column;

    flex: 1 1 auto;

    @media (max-height: 900px) {
      min-height: 70vh;
    }
    @media (max-width: ${BREAKPOINTS.medium}px) {
        min-height: unset;
    }
`;
